import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

const SyncableProviderSchema = z.enum([
  Provider.SHOPIFY,
  Provider.BIGCOMMERCE,
  Provider.COMMENTSOLD,
  Provider.COMMERCE_CLOUD,
  Provider.APTOS,
]);

export type SyncableProvider = z.infer<typeof SyncableProviderSchema>;

export const SYNCABLE_PROVIDERS: ReadonlySet<SyncableProvider> = new Set(
  SyncableProviderSchema.options,
);

export function isSyncableProvider(
  provider: string,
): provider is SyncableProvider {
  return (SYNCABLE_PROVIDERS as ReadonlySet<string>).has(provider);
}

export const syncOrderByProviderId = {
  name: "syncOrderByProviderId" as const,
  input: z.object({
    provider: SyncableProviderSchema,
    orderIdentifier: z.string().min(1, "Order identifier is required"),
    commerceCloudSite: z
      .object({ integrationId: z.string(), siteId: z.string() })
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
